module.exports = __webpack_public_path__ + "img/hands.0a56363a.png";